module.exports = __webpack_public_path__ + "static/media/WorkforceHero.0c8c08a2.png";